<template>
  <div>
    <div class="row no-gutters">
      <div class=" col-md-12">
        <KTCodePreview>

          <template v-slot:body>
            <v-card-title>
              <!-- <ButtonComponent colors="#17A1FA" name="csv" @click.native="$func.exportCsv">
                </ButtonComponent> -->
              <v-spacer></v-spacer>
              <v-text-field v-model="search" label="Search" single-line hide-details></v-text-field>
            </v-card-title>
            <v-data-table :headers="headers" :items="dataWithIndex" :search="search">
              <!-- <template v-slot:item.no="{ index }">
                  {{ index + 1 }}.
                </template> -->
              <template v-slot:item.action="{ item }">
                <ButtonComponent colors="#3751E4" name="check_krs" v-b-modal.modal @click.native="openModal(item)"
                  dataTitleTooltip="Open" title="Approve KRS" />
              </template>
            </v-data-table>
          </template>
        </KTCodePreview>

      </div>
    </div>
    <b-modal @ok="onSubmit" ok-title="Simpan" ok-variant="primary" cancel-title="Batal" cancel-variant="danger"
      no-enforce-focus size="lg" id="modal" :title="`Approval KRS`">
      <b-form>
        <div class="row">
          <div class="col-lg-1 mb-0">
            Nama
          </div>
          <div class="col-lg-6">
            : {{ request.name }}
          </div>
        </div>
        <div class="row">
          <div class="col-lg-1 pt-1">
            Semester
          </div>
          <div class="col-lg-6 pt-1">
            : {{ request.phases }}
          </div>
        </div>
        <div class="row">
          <div class="col-lg-1 pt-1">
            Prodi
          </div>
          <div class="col-lg-6 pt-1 mb-2">
            : {{ request.program_name }}
          </div>
        </div>
        <!-- kalau tidak select all only kasih -> item-key="key_krs" -->
        <v-data-table :headers="modal_headers" :items="data_headers" :search="search" show-select v-model="selected"
          :single-select="false" class="elevation-1">
          <template v-slot:item.no="{ index }">
            {{ index + 1 }}.
          </template>
        </v-data-table>
      </b-form>
    </b-modal>
    <!-- content end -->
  </div>
</template>

<script>
import KTCodePreview from "@/view/content/CardContent.vue";
import ButtonComponent from "@/view/content/components/button/buttonComponent.vue";
import axios from "axios";

export default {
  data() {
    return {
      search: "",
      request: {
        generation_id: null,
        student_id: null,
        name: null,
        phases: null,
        program_name: null
      },
      selected: [],
      data: [],
      headers: [
        { text: "No", value: "no", align: "center", sortable: false },
        { text: "NRP", value: "NIM" },
        { text: "Nama", value: "name" },
        { text: "Prodi", value: "program_name" },
        { text: "Semester", value: "phases" },
        { text: "Aksi", value: "action", align: "center", sortable: false },
      ],
      data_headers: [],
      modal_headers: [
        { text: "No", value: "no", align: "center", sortable: false },
        { text: "Kode Mata Kuliah", value: "course_code" },
        { text: "Mata Kuliah", value: "course_name" },
        { text: "SKS", value: "credits" },
        { text: '', value: 'data-table-select' }
      ],
      statusModal: "",
    };
  },
  computed: {
    dataWithIndex() {
      return this.data.map(
        (data, index) => ({
          ...data,
          no: index + 1
        }))
    }
  },
  components: {
    KTCodePreview,
    ButtonComponent,
  },
  async mounted() {

    await this.getData();
  },
  methods: {
    async openModal(itemData = null) {
      // reset form
      this.data_headers = []
      this.request = {
        generation_id: null,
        student_id: null,
        name: null,
        phases: null,
        program_name: null
      };
      this.request.generation_id = itemData.generation_id
      this.request.student_id = itemData.student_id
      this.request.name = itemData.name
      this.request.phases = itemData.phases
      this.request.program_name = itemData.program_name
      const result = await axios.get(`master/krs-siswa/krs-detail/${this.request.student_id}/${this.request.generation_id}`)
      this.data_headers = result.data.data
    },

    async getData() {

      try {
        const result = await axios.get(
          `master/krs-siswa/list-siswa`
        );
        this.data = []
        for (var i = 0; i < result.data.data.length; i++) {
          if (result.data.data[i].approval == 0) {
            this.data.push(result.data.data[i])
          }
        }

      } catch (err) {
        this.$swal(`Failed`);
      }
    },

    async onSubmit() {
      if (this.selected.length != 0) {
          var formData = {
            student: this.request.student_id,
            generation: this.request.generation_id,
            approval: "1",
          };

          const result = await axios.put(`master/krs-siswa/approve/`, formData)
          if (result.data.meta.code == 200) {
            this.$swal(`Success Approved KRS`);
            // this.$router.go()
            this.getData()
            // this.$swal({
            //   title: 'Success Approved KRS',
            //   showCancelButton: false,
            //   confirmButtonText: 'OK',
            //   confirmButtonColor: '#3085d6',
            // }).then(async (result) => {
            //   if (result.value) {
            //     // User confirmed, so delete the item
            //     this.$router.go()
            //   } else {
            //     // User canceled, so do nothing
            //   }
            // })
          } else {
            this.$swal(`Failed1`);
          }
      }

    },

  },
};
</script>
